
function GetSerializedCartBundleItem(target,parsedQuantity)
{
    var rawids = target.getAttribute('data-line-id');
  	var ids = rawids.split('|');
  var body = '{"updates":{';
   for (var i = 0; i < ids.length; i++) {
    //body = body + '{';
   // body = body + 'id:' + ids[i];
   // body = body + ',';
   // body = body + 'quantity:' + parsedQuantity;
   // body = body + '}';
     body = body + '"' +  ids[i] + '":';
     body = body +parsedQuantity;
    if (i != ids.length-1)
    {
      body = body + ',';
    }
   }
  body =  body + '}}';
  
  //console.log(JSON.stringify(body));
  //return JSON.stringify({body});
  //console.log(body);
  return body;
}

function GetSerializedCartBundleItemFromKey(bundleKey, quantity)
{
var ids = bundleKey.split('|');
  var body = '{"updates":{';
   for (var i = 0; i < ids.length; i++) {
     body = body + '"' +  ids[i] + '":';
     body = body +quantity;
    if (i != ids.length-1)
    {
      body = body + ',';
    }
   }
  body =  body + '}}';
  return body;
}

function DelayPromise(ms, promise) {
 // alert('here');
        
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => { console.log('rejected');
      reject(new Error('TIMEOUT'))
    }, ms)

    promise
      .then(value => {
        clearTimeout(timer)
        resolve(value)
          console.log(value);
      })
      .catch(reason => {
        clearTimeout(timer)
        reject(reason)
         console.log(reason);
      })
  })
}

function GetCalculatedCartItemsQty(cart)
{
  //console.log(cart);
  var cart_items_count = cart.item_count;
  var eco_fee_count = 0;
  for (var i = 0; i < cart.items.length; i++) {
   	if (!isEmpty(cart.items[i].properties))
    {
     // console.log(cart.items[i]);
      var properties = cart.items[i].properties;
      if (properties._is_fee != undefined)
      {
       	 if (properties._is_fee == "true")
         {
           eco_fee_count = eco_fee_count + cart.items[i].quantity;
         }
      }
    }
  }
  //console.log(cart_items_count);
  // console.log(eco_fee_count);
  
  return (cart_items_count - eco_fee_count);
}

function isEmpty(obj) {
  for(var prop in obj) {
    if(obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

async function setCartAttributes(attributes = {}) {
  try{
    const response = await fetch(`${window.routes.cartUpdateURL}.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        attributes: attributes,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    console.log("Success:", data.attributes);
  }
  catch(error){
     console.error(`Could not set attributes: ${error}`);
  } 
}
 

function UpgradeItemInCart(Form, data) {
  data.parentElement.disabled = true;
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  const handle = data.querySelectorAll('input[name="_master"]')[0].value;
  const newItem = SeriaizeFormWithArray(Form, data, handle);
  const key = data.getAttribute('key');
  const itemRemoveButton = document.querySelectorAll('[data-line-key="'+key+'"]');
  const removeButtons= document.querySelectorAll('a.line-item__quantity-remove');
  const quantityButtons = document.querySelectorAll('button.quantity-selector__button');
  for(let link of removeButtons) {
    link.classList.add('disabled-link');
  }
  for(let button of quantityButtons) {
    button.disabled = true;
  }
  if(itemRemoveButton.length >= 1) {
    /* we add the new item first since the hash in the key will change when the new item gets added and we can safely remove the original item with the key from the form */
    AddItemToCart(newItem).then(addedData => {
      const originalItem = GetSerializedCartBundleItem(itemRemoveButton[0],0);
      return UpdateItemInCart(originalItem);
    }).then(removedData => {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      location.replace(location.href);
    }).catch((e) => {
      console.error('UpgradeItemInCart error:', e.cause ? e.cause : e);
      for(let link of removeButtons) {
        link.classList.remove('disabled-link');
      }
      for(let button of quantityButtons) {
        button.disabled = false;
      }
    });
  }
}

async function AddItemToCart(serializedForm) {
  const response = await fetch("".concat(window.routes.cartAddUrl, ".js"), {
    body: serializedForm,
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  });
  if(response.status !== 200) {
    throw new Error('AddItemToCart request was unsuccessful', { cause: response });
  }
  const responseData = await response.json();
  return responseData;
}

async function UpdateItemInCart(serializedCartItem) {
  const response = await fetch("".concat(window.routes.cartUpdateURL, ".js"), {
    body: serializedCartItem,
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  });
  if(response.status !== 200) {
    throw new Error('UpdateItemInCart request was unsuccessful', { cause: response })
  }
  const responseData = await response.json();
  return responseData;
}
